import {BaseSearchableService} from "./Core/BaseSearchableService";

class HucService extends BaseSearchableService {
    get Url() { return super.Url + "/hucs"; }
    get ModelName() { return "Huc"; }
    get PrimaryKeyProperty() { return "hucId"; }
    get TitleProperty() { return "name"; }
    get SubtitleProperty() { return "hucCode"; }
    
    get Request() {
        return {...super.Request, level: 4};
    }

    Get() {
        return this.SendRequest(BaseSearchableService.GET, this.request);
    }

    GetSubtitle(model) {
        return model ? "Huc ID: " + model.hucCode : "";
    }
}

export const service = new HucService();

